/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Carousel } from "@mantine/carousel";
import moment from "moment";
import React, { useEffect, useState } from 'react';
import htmlParser from 'react-html-parser';
import { BsBoxArrowInUpRight } from "react-icons/bs";
import { FaGithub, FaHashtag } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import Halment from "../faetures/Halment";
import Layout from '../layout/Layout';
import { getAllPortfolioNoPage } from '../redux/actions/frontendActions/portfolioActions';



function Portfolio() {


  const dispatch =useDispatch();
  const {allportfolios} = useSelector(state => state.Portfolio);
console.log(allportfolios);

  // const Tag = allportfolios[0]?.tools
  // console.log(typeof(Tag));



  useEffect(() => {
    dispatch( getAllPortfolioNoPage())
  }, [dispatch]);
  const [fiterState, setFilterState] = useState("");
  const [Allselect , setAllSelect] =useState(true);
  const [Frontselect , setFrontSelect] =useState(false);
  const [Backselect , setBackSelect] =useState(false);
  const [Wpselect , setWpSelect] =useState(false);


  const handleALlSelect =()=>{
    setAllSelect(true)
    setWpSelect(false)
    setBackSelect(false)
    setFrontSelect(false)
  }
  const handleFrontSelect =()=>{
    setFrontSelect(true)
    setBackSelect(false)
    setWpSelect(false)
    setAllSelect(false)
  }
  const handleBackSelect =()=>{
    setBackSelect(true)
    setFrontSelect(false)
    setWpSelect(false)
    setAllSelect(false)
  }
  const handleWPSelect =()=>{
    
    setWpSelect(true)
    setAllSelect(false)
    setBackSelect(false)
    setFrontSelect(false)
   
  }

  
 




  return (
    <Layout>
       <Halment title="Portfolio" />
      <div className="megazine_wrapper-area">
        <div className="slider_area">
          <Carousel
            withIndicators
            height={350}
            slideSize="33.333333%"
            slideGap="md"
            breakpoints={[
              { maxWidth: "md", slideSize: "50%" },
              { maxWidth: "sm", slideSize: "100%", slideGap: 0 },
            ]}
            loop
            align="start"
          >
            {allportfolios.length > 0 ? (
              allportfolios.map((blog, index) => (
                <Carousel.Slide key={index}>
                  <Link to={`/portfoliodata/${blog._id}`} className="carosel_box">
                    <div className="img-area">
                      <img src={blog.image} alt="" />
                    </div>
                    <div className="text-area">
                      <h1>{blog.title}</h1>
                      <div className="date_flex">
                      <p>{moment(blog.createdAt).fromNow()}</p>
                        <p>Md Asraful</p>
                      </div>
                    </div>
                  </Link>
                </Carousel.Slide>
              ))
            ) : (
              <h1 style={{color: "#fff"}}>Loading......</h1>
            )}
          </Carousel>
        </div>
      </div>


      <div className="top_filter_button_area">
          <div className="button_group">
          <div>
              <NavLink to="#"
              className={Allselect  ? "select": "denied"}
              onClick={handleALlSelect} 
              
              >
                <button
                  onClick={() => setFilterState("")}
                  value="all"
                >
                  All
                </button>
              </NavLink>
            </div>
            <div>
              <NavLink to="#"
              className={Frontselect  ? "select": "denied"}
              onClick={handleFrontSelect} 
              
              >
                <button
                  onClick={() => setFilterState("frontend")}
                  value="frontend"
                >
                  Frontend
                </button>
              </NavLink>
            </div>
            <div>
              <NavLink to="#"
                className={Backselect  ? "select": "denied"}
                onClick={handleBackSelect} 
               
              >
                <button
                  onClick={() => setFilterState("fullstack")}
                  value="fullstack"
                >
                  Full stack
                </button>
              </NavLink>
            </div>
            <div>
              <NavLink to="#"
              className={Wpselect  ? "select": "denied"}
              onClick={handleWPSelect} 
                
              >
                
                <button
                  onClick={() => setFilterState("wordpress")}
                  value="wordpress"
                >
                  Wordpress
                </button>
              </NavLink>
            </div>
          </div>
      </div>

      {/* portfolio card  */}

      <div className="margin_container">
          <div className="portfolio_card_wrapper_area">
                

                {
                  allportfolios.length> 0 ? allportfolios.filter((obj) =>
                  obj.categories.toLowerCase().includes(fiterState)
                ).map((p ,i) =><Link to="#" className="card">
                  <div className="image-area">
                    <img src={p.image} alt="" />
                  </div>
                  <div className="text-area">
                    <h3>{p.title}</h3>
                    <p>{htmlParser(p?.description.slice(0 , 220))}...
                      <br />
                      <Link to={`/portfoliodata/${p._id}`}>See Details &gt;&gt; </Link>
                    </p>
                   
                  </div>
                  <ul className="tool-area">
                  
                  {
                    p.tools[0].split(",").map((tag , index) => <li key={index}><FaHashtag/>{tag}</li> )
                  }
                 
                 
                  </ul>
                  <div className="card-bottom">
                  
                    <div className="left">
                    <a href={p.codeLink}>   <FaGithub/></a>
                    <a href={p.liveLink}> <BsBoxArrowInUpRight/></a>
                    </div>
                    <div className="right">
                      <h6>{p.categories}</h6>
                    </div>
                  </div>
                </Link>) : <h1>Loading...</h1>
                }
               
                
          </div>
      </div>

      
    </Layout>
  )
}

export default Portfolio